import { ProcessLanguageLevelDto, ProcessRequirementsSectionTypeDto } from '@/api/generated';
import { createProcessTranslation } from '@/assets/locales/views/processes/createProcess/createProcess.translation.pl.ts';
import { processDetailsTranslation } from '@/assets/locales/views/processes/details/processDetails.translation.pl.ts';
import { processListTranslation } from '@/assets/locales/views/processes/list/processList.translation.pl.ts';
import { ProcessesTranslation } from '@/assets/locales/views/processes/processes.translation.en.ts';

export const processesTranslation: ProcessesTranslation = {
  createProcess: createProcessTranslation,
  details: processDetailsTranslation,
  form: {
    buttons: {
      back: 'Cofnij',
      close: 'Zamknij',
      next: 'Dalej',
      save: 'Zapisz',
    },
    languages: {
      addNewLanguage: 'Nowy język',
      infotip: 'Każdy język jest automatycznie uwzględniany w analizie AI z najwyższą wagą (W5).',
      level: 'Poziom',
      newLanguagePlaceholder: 'wpisz nazwę języka',
      tabs: {
        [ProcessLanguageLevelDto.Advanced]: 'Zaawansowany',
        [ProcessLanguageLevelDto.Basic]: 'Podstawowy',
        [ProcessLanguageLevelDto.Intermediate]: 'Średniozaawansowany',
        [ProcessLanguageLevelDto.Native]: 'Rodzimy',
        [ProcessLanguageLevelDto.Proficient]: 'Biegły',
        [ProcessLanguageLevelDto.Unknown]: 'Unknown',
      },
      title: 'Języki',
    },
    redFlags: {
      addNewRedFlag: 'dodaj nowe ostrzeżenie',
      infotip:
        'Wypisz w poniższym polu czerwone flagi, które należy uwzględnić przy analizie wymagań procesu.',
      newRedFlagsPlaceholder: 'wpisz ostrzeżenie',
      title: 'Zagrożenia',
    },
    requirements: {
      addNew: 'Dodaj Nowe',
      infotip: 'Przesuń suwak od 1 do 5, aby ocenić, jak ważna jest dane zagadnienie w procesie.',
      newRequirementPlaceholders: {
        [ProcessRequirementsSectionTypeDto.NiceToHave]: 'wprowadź nowe, mile widziane zagadanienie',
        [ProcessRequirementsSectionTypeDto.Required]: 'wprowadź nowe, wymagane zagadnienie',
      },
      tabs: {
        [ProcessRequirementsSectionTypeDto.NiceToHave]: 'Mile widziane',
        [ProcessRequirementsSectionTypeDto.Required]: 'Wymagane',
      },
      title: 'Wymagnia',
    },
    title: {
      setProcessLanguages: 'Ustaw wymagane języki',
      setProcessRedFlags: 'Ustaw ostrzeżenia dla procesu',
      setProcessRequirements: 'Ustaw wymagania dla procesu',
    },
  },
  list: processListTranslation,
};
